import { useOperatorTasks } from '@/entities/OperatorTask/model/store';
import type { OperatorTaskAssigneeResponse } from '@/core/generated/api';
import { operatorTaskService } from '@/entities/OperatorTask/api/operatorTaskService';
import { AsyncSearchField, type AsyncSearchOption } from '@/shared/ui/AsyncSearchField/AsyncSearchField';

interface TaskAssigneeFieldProps {
    name: string;
    value?: OperatorTaskAssigneeResponse | null;
    onChange: (value: OperatorTaskAssigneeResponse | null) => void;
    onBlur: () => void;
    disabled: boolean;
    error?: string;
    placeholder?: string;
}

/** Подготавливает логин и роль сотрудника для выбора */
const toOption = (
    user: OperatorTaskAssigneeResponse
): AsyncSearchOption<string, OperatorTaskAssigneeResponse> => ({
    id: user.id ?? '',
    name: [user.login, user.role?.name].filter(Boolean).join(' · '),
    data: user,
});

/** Выбирает необязательного ответственного из действующих сотрудников */
export const TaskAssigneeField = (
    { name, value, onChange, onBlur, disabled, error, placeholder = 'Не назначен · поиск по логину' }: TaskAssigneeFieldProps
) => {
    const options = useOperatorTasks((state) => state.options);

    return (
        <AsyncSearchField<string, OperatorTaskAssigneeResponse>
            name={name}
            label="Ответственный"
            placeholder={placeholder}
            value={value?.id ?? null}
            initialOption={value?.id
                ? toOption(value)
                : null
            }
            onChange={(_id, option) => onChange(option?.data ?? null)}
            onBlur={onBlur}
            loadOptions={async (query) => {
                const response = await operatorTaskService.assignees(query);

                return (response.items ?? []).filter((user) => user.id && user.isAvailable).slice(0, 7).map(toOption);
            }}
            minSearchLength={options?.minLookupSearchLength ?? 0}
            cacheScope={`${options?.lookupDefaultTake}-${options?.lookupMaxTake}-${options?.minLookupSearchLength}`}
            scrollHeight="18rem"
            emptyMessage="Нет доступных сотрудников"
            disabled={disabled}
            error={error}
        />
    );
};
